module.exports = __webpack_public_path__ + "img/cn-tr.f6609864.svg";